export default {
  namespaced: true,

  state: {
    isOpen: false,
    text: '',
    color: '',
  },

  actions: {
    open({ state }, { color, text }) {
      state.text = text;
      state.isOpen = true;
      state.color = color;
    },

    openError({ dispatch }, text) {
      dispatch('open', { text, color: 'red' });
    },

    openWarning({ dispatch }, text) {
      dispatch('open', { text, color: 'orange' });
    },

    openSuccess({ dispatch }, text) {
      dispatch('open', { text, color: 'green' });
    },

    close({ state }) {
      state.isOpen = false;
    },
  },
};
